// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import useConfig from '@hooks/useConfig';

import { handlerDrawerOpen, useGetMenuMaster } from '@api/menu';

// assets
import { IconMenu2 } from '@tabler/icons-react';
import { ThemeMode } from '@app/types/config';
import NotificationSection from '@layout/MainLayout/NotificationSection';
import HelpCenterSection from '@layout/MainLayout/HelpCenterSection';
import FullScreenSection from './FullScreenSection';
import ProfileSection from '../ProfileSection';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

function Header() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const { mode } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? 'auto' : 228, display: 'flex' }}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            overflow: 'hidden',
            transition: 'all .2s ease-in-out',
            bgcolor: mode === ThemeMode.DARK ? 'dark.main' : 'secondary.light',
            color:
              mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
            '&:hover': {
              bgcolor:
                mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
              color:
                mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light',
            },
          }}
          onClick={() => handlerDrawerOpen(!drawerOpen)}
          color="inherit"
        >
          <IconMenu2 stroke={1.5} size="20px" />
        </Avatar>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      <HelpCenterSection />

      <NotificationSection />

      {/* full screen toggler */}
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <FullScreenSection />
      </Box>

      {/* profile */}
      <ProfileSection fromSidebar={false} />
    </>
  );
}

export default Header;
